import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import clsx from 'clsx'
import { useFormattingContext } from '../../FormattingProvider/FormattingContext'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'
import { useTitle } from './useTitle'

function PipelineMiniMetric ({ pipeline, variables, metricAccessor, format, name, className, style }) {
  const { formatter } = useFormattingContext()
  const { data, isLoading } = usePipelineDataContextWithVariables(pipeline, variables)
  const metric = useMemo(() => {
    const metricValue = get(data, metricAccessor)
    return formatter(metricValue, format)
  }, [data, metricAccessor, formatter, format])
  const [nameSingle, nameMulti] = useTitle(name)

  if (isLoading) {
    return null
  }

  return (
    <div className={clsx(className, 'flex flex-col items-center')} style={style}>
      <div className='font-size-sm'>
        {metric}
      </div>
      {name ? (
        <div className='font-size-xs font-weight-thin' style={{ fontWeight: 'var(--font-weight-thin)' }}>
          {metric === 1 ? nameSingle : nameMulti}
        </div>
      ) : null}
    </div>
  )
}

PipelineMiniMetric.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  variables: PropTypes.object,
  metricAccessor: PropTypes.string,
  format: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string,
  style: PropTypes.object
}

export default PipelineMiniMetric
